// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as SkilfulClozeCommon$LiteracyplanetTupperware from "./SkilfulClozeCommon.res.mjs";
import * as V2ClozeDropTextHook$LiteracyplanetTupperware from "./V2ClozeDropTextHook.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";
import * as PilotClozeDropTextContainer$LiteracyplanetTupperware from "../v3/PilotClozeDropTextContainer.res.mjs";

function SkilfulClozeDropTextContainer$ResponseContainer(props) {
  return React.createElement("span", {
              ref: props.drop,
              className: Skillet$LiteracyplanetTupperware.SkilfulClozeDropTextContainer.ResponseContainer.className,
              id: "DropId-" + props.id
            }, props.children);
}

var ResponseContainer = {
  make: SkilfulClozeDropTextContainer$ResponseContainer
};

function SkilfulClozeDropTextContainer$UndroppedIsOver(props) {
  return React.createElement(SkilfulClozeDropTextContainer$ResponseContainer, {
              drop: Caml_option.some(props.drop),
              id: props.id,
              children: React.createElement("span", {
                    className: Skillet$LiteracyplanetTupperware.SkilfulClozeDropTextContainer.UndroppedIsOver.className
                  }, props.children)
            });
}

var UndroppedIsOver = {
  make: SkilfulClozeDropTextContainer$UndroppedIsOver
};

function SkilfulClozeDropTextContainer$Undropped(props) {
  return React.createElement(SkilfulClozeDropTextContainer$ResponseContainer, {
              drop: Caml_option.some(props.drop),
              id: props.id,
              children: React.createElement("span", {
                    className: Skillet$LiteracyplanetTupperware.SkilfulClozeDropTextContainer.Undropped.className
                  }, props.children)
            });
}

var Undropped = {
  make: SkilfulClozeDropTextContainer$Undropped
};

function SkilfulClozeDropTextContainer$EmptyPortalContainer(props) {
  var __isOver = props.isOver;
  var isOver = __isOver !== undefined ? __isOver : false;
  var className = isOver ? Skillet$LiteracyplanetTupperware.SkilfulClozeDropTextContainer.DroppedIsOver.className : undefined;
  return React.createElement("span", {
              ref: props.drop,
              className: className,
              id: "DropId-" + props.id
            }, null);
}

var EmptyPortalContainer = {
  make: SkilfulClozeDropTextContainer$EmptyPortalContainer
};

function SkilfulClozeDropTextContainer$MarkedNotDropped(props) {
  return React.createElement(SkilfulClozeDropTextContainer$ResponseContainer, {
              id: props.id,
              children: React.createElement(SkilfulClozeCommon$LiteracyplanetTupperware.IncorrectResponse.make, {
                    children: React.createElement("span", {
                          className: Skillet$LiteracyplanetTupperware.SkilfulClozeDropTextContainer.MarkedNotDropped.className
                        }, props.children)
                  })
            });
}

var MarkedNotDropped = {
  make: SkilfulClozeDropTextContainer$MarkedNotDropped
};

function SkilfulClozeDropTextContainer$Skilful(props) {
  var children = props.children;
  var id = props.id;
  var match = V2ClozeDropTextHook$LiteracyplanetTupperware.use(props.questionIndex, id);
  var drop = match[4];
  var step = match[3];
  var answerVisible = match[2];
  var isOver = match[0];
  var exit = 0;
  if (answerVisible !== undefined) {
    if (answerVisible) {
      return React.createElement(SkilfulClozeDropTextContainer$EmptyPortalContainer, {
                  id: id
                });
    }
    exit = 1;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (match[1]) {
      var exit$1 = 0;
      if (typeof step !== "object") {
        exit$1 = 2;
      } else {
        if (step.TAG !== "Attempted") {
          return React.createElement(SkilfulClozeDropTextContainer$EmptyPortalContainer, {
                      id: id
                    });
        }
        exit$1 = 2;
      }
      if (exit$1 === 2) {
        if (isOver) {
          return React.createElement(SkilfulClozeDropTextContainer$EmptyPortalContainer, {
                      drop: Caml_option.some(drop),
                      id: id,
                      isOver: isOver
                    });
        } else {
          return React.createElement(SkilfulClozeDropTextContainer$EmptyPortalContainer, {
                      drop: Caml_option.some(drop),
                      id: id
                    });
        }
      }
      
    } else {
      var exit$2 = 0;
      if (typeof step !== "object") {
        exit$2 = 2;
      } else {
        if (step.TAG !== "Attempted") {
          return React.createElement(SkilfulClozeDropTextContainer$MarkedNotDropped, {
                      id: id,
                      children: children
                    });
        }
        exit$2 = 2;
      }
      if (exit$2 === 2) {
        if (isOver) {
          return React.createElement(SkilfulClozeDropTextContainer$UndroppedIsOver, {
                      drop: drop,
                      id: id,
                      children: children
                    });
        } else {
          return React.createElement(SkilfulClozeDropTextContainer$Undropped, {
                      drop: drop,
                      id: id,
                      children: children
                    });
        }
      }
      
    }
  }
  
}

var Skilful = {
  make: SkilfulClozeDropTextContainer$Skilful
};

function SkilfulClozeDropTextContainer(props) {
  var children = props.children;
  var id = props.id;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotClozeDropTextContainer$LiteracyplanetTupperware.make, {
                id: id,
                children: children
              });
  } else {
    return React.createElement(SkilfulClozeDropTextContainer$Skilful, {
                questionIndex: props.questionIndex,
                id: id,
                children: children
              });
  }
}

var make = SkilfulClozeDropTextContainer;

var $$default = SkilfulClozeDropTextContainer;

export {
  ResponseContainer ,
  UndroppedIsOver ,
  Undropped ,
  EmptyPortalContainer ,
  MarkedNotDropped ,
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
